"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsletterSubscribe = exports.Name = void 0;
const Name = exports.Name = 'newsletter-subscribe';
const NewsletterSubscribe = exports.NewsletterSubscribe = Name;
